import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=3a1b2ebc&scoped=true"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"
import style0 from "./whatsapp.vue?vue&type=style&index=0&id=3a1b2ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b2ebc",
  null
  
)

export default component.exports